export {
  onBroadcastEvent,
  registerEvent,
  unRegisterEvent,
};

// 'player-mesh-loader-config',
const allowList = new Set();

function registerEvent (event) {
  allowList.add(event);
}

function unRegisterEvent (event) {
  allowList.delete(event);
}

/**
 * @this {MggpPluginInteractive}
 * @param {{event: {name: string, payload: *}, videoId: string}} data
 */
// eslint-disable-next-line complexity
function onBroadcastEvent (data) {
  const predicate = [
    !!(data?.event?.name),
    allowList.has(data.event.name)
  ].every(Boolean);

  if (false === predicate){
    return;
  }

  try {
    this.player.emit.call(null, data.event.name, data.event.payload);
  } catch (e) {
    console.error(e);
  }
}
